var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "canvas::editor-admin-ToolbarTop flex w-full flex-col" },
    [
      _c("div", { staticClass: "mb-0 w-full" }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticClass: "px-5 py-10 sm:px-10" }, [
            _c("div", { staticClass: "flex items-center" }, [
              _c("h4", { staticClass: "text-2xl font-bold inline-block" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "ml-3 text-blue-500 rounded px-2 py-1 hover:bg-gray-50",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:fullscreen", !_vm.fullscreen)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "far",
                    class: _vm.fullscreen ? "fa-compress-alt" : "fa-expand-alt",
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-lg text-gray-500" }, [
              _vm._v(_vm._s(_vm.instruction)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "versionInfo ml-auto text-right flex px-5 py-10 sm:px-10",
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "label inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium",
                    class:
                      _vm.versionState === "live"
                        ? "bg-green-100 text-green-800"
                        : "bg-yellow-100 text-yellow-800",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("camelcase")(_vm.versionState)) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.activeCanvasVersion
                  ? _c(
                      "h6",
                      { staticClass: "card-subtitle mb-0 mt-2 text-gray-500" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.versionState === "live"
                                ? "Gepubliceerd"
                                : "Live versie gepubliceerd"
                            ) +
                            "\n                        "
                        ),
                        _vm.authorName
                          ? [
                              _vm._v("door "),
                              _c("b", [_vm._v(_vm._s(_vm.authorName))]),
                            ]
                          : _vm._e(),
                        _vm._v("\n                        op "),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(
                                _vm.activeCanvasVersion.activated_at,
                                "%d-%m-%Y %H:%M"
                              )
                            )
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.currentLanguageToShow
                ? _c("div", { staticClass: "ml-4" }, [
                    _c("i", {
                      staticClass: "flag-icon",
                      class:
                        "flag-icon-" +
                        (_vm.currentLanguageToShow == "en"
                          ? "gb"
                          : _vm.currentLanguageToShow),
                    }),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }